/** Must match consumer-web-elements `add-to-cart-event.ts`. */
export const PC_ADD_TO_CART_EVENT = "pc:add-to-cart" as const;

/** Surface an add-to-cart originated from. Drives future analytics. */
export type AddToCartSource =
	| "pdp"
	| "pdp-recommended"
	| "atc-recommended"
	| "cart-recommended"
	| "recently-viewed";

export type AddToCartEventDetail = {
	productCode: string;
	quantity: string;
	purchaseType: "oneTime" | "monthly";
	// Mandatory: every add-to-cart must declare its originating surface.
	source: AddToCartSource;
};

export function isAddToCartEventDetail(
	value: unknown
): value is AddToCartEventDetail {
	if (value == null || typeof value !== "object") return false;
	const o = value as Record<string, unknown>;
	return (
		typeof o.productCode === "string" &&
		typeof o.quantity === "string" &&
		(o.purchaseType === "oneTime" || o.purchaseType === "monthly") &&
		typeof o.source === "string"
	);
}
